<template>
  <div class="container market text-center mt-4">
    <div class="head-title pb-0 px-4">
      <h2 class="text-uppercase">MarketPlace</h2>
    </div>
    <div class="back-btn">
      <router-link to="/dashboard">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </router-link>
    </div>
    <section class="inventory-section marketPlace-section mt-4">
      <div class="row">
        <div class="col-md-2">
          <form action="#" class="search-input">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="{2}"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <input
              type="search"
              placeholder="search"
              v-model="searchTerm"
              @keyup="search($event)"
              @paste="search($event)"
            />
          </form>
          <div class="btn-container">
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'supplies' ? 'selected' : ''}`"
              @click="filter('supplies')"
              >Supplies</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'foods' ? 'selected' : ''}`"
              @click="filter('foods')"
              >Food</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'ports' ? 'selected' : ''}`"
              @click="filter('ports')"
              >Ports</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'equipments' ? 'selected' : ''}`"
              @click="filter('equipments')"
              >Equipments</a
            >
            <a
              href="javascript:void(0)"
              class="md-btn pulse"
              :class="`${searchTerm == 'packs' ? 'selected' : ''}`"
              @click="filter('packs')"
              >Packs</a
            >
          </div>
        </div>
        <div class="col-md-10 text-left">
          <loading
            v-model:active="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
          />
          <div class="inventory-card">
            <div class="row">
              <div class="col-md-4" v-for="(item, index) in info" :key="index">
                <div class="card">
                  <div class="img-wrapper">
                    <a href="#" class="img-position single-pic">
                      <div class="img-prev">
                        <img
                          :src="getImgUrl(item.asset.immutable_data.img)"
                          alt=""
                        />
                      </div>
                    </a>
                  </div>

                  <div class="card-body">
                    <h4 class="card-title m-0 asset-name">
                      {{ item.asset.immutable_data.name }}
                    </h4>
                    <p class="card-text p-0 m-0">
                      {{ Number(parseFloat(item.price)).toFixed(2) }} DOUB
                    </p>
                    <p class="supply">
                      Supply {{ item.supply }} / Left
                      {{ Number(item.supply) - Number(item.total_sale) }}
                    </p>
                    <div class="buttons mt-2">
                      <!-- <button class="small-btn" @click="redirectToDetails(item.asset_t)">Details</button> -->
                      <button
                        class="w-100 small-btn ml-5 bg-white text-black"
                        @click="buy(item.asset_t, item.price)"
                      >
                        Buy
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <h1 v-if="info && !info.length" style="margin-right: 212px">
                no data found.
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import router from "@/router";
import ApiService from "../services";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "MarketPlace",
  computed: {
    ...mapGetters(["balance", "level"]),
  },
  components: {
    Loading,
  },
  data() {
    return {
      userFilter: null,
      authenticator: null,
      userCollection: "midgardclash",
      info: null,
      apiRes: null,
      collections: null,
      searchTerm: "",
      isLoading: false,
      fullPage: true,
      assetId: "",
      row: {},
      assetIds: [],
      showModal: false,
      showStackModal: false,
      error: false,
      rarity: "All RARITY",
      activeMenuSearch: false,
      activeMenu: false,
      goldCoin: false,
    };
  },
  mounted() {
    // this.init("&page=1&limit=100");
    this.isLoading = true;
    ApiService.market((res) => {
      this.info = res;
      this.apiRes = res;
      this.isLoading = false;
      this.$store.commit("addMarket", this.info);
    });
    // ApiService.genericCall(
    //         `collection_name=lostsailorsl&schema_name=coins`,
    //         (response) => {
    //           let res = response["data"];
    //           if (res["success"]) {
    //             const coins = res["data"];
    //             if(coins.length)
    //             this.goldCoin = coins[0].asset_id;
    //           }
    //         }
    //     );
  },
  methods: {
    redirectToDetails(id) {
      router.push(`/marketDetails/${id}`);
    },
    calculatePrice(price) {
      return `${price.amount / 100000000} ${price.token_symbol}`;
    },
    filter(term) {
      this.searchTerm = term;
      this.info = this.apiRes.filter((el) => el.schema == term);
    },
    search() {
      this.info = this.apiRes.filter((el) =>
        el.asset.name.includes(this.searchTerm)
      );
    },
    getImgUrl(hash) {
      let url = "http://ipfs.io/ipfs/" + hash;
      return "//lostsailor/images.weserv.nl/?url=" + url + "&w=500";
    },
    async buy(templateId, price) {
      if (process.env.VUE_APP_PORT_TEMPID == templateId && this.goldCoin) {
        this.buyTransact(templateId, price, this.goldCoin);
      } else {
        this.buyTransact(templateId, price, false);
      }
    },
    async buyTransact(templateId, price, coins) {
      const memo = coins ? `${templateId}:1:${coins}` : `${templateId}:1`;
      if (templateId && price) {
        await ApiService.buy(
          {
            from: localStorage.getItem("wax_user"),
            to: process.env.VUE_APP_CONTRACT,
            quantity: price,
            memo: memo,
          },
          (res) => {
            if (res.processed) {
              toast.success("Transaction processing.");
            }
          },
          (error) => {
            error = ApiService.errorFormat(error);
            toast.error(error);
          }
        );
      } else {
        this.error = "Please specify quantity";
        toast.error(this.error);
      }
    },
  },
};
</script>
<style scoped>
.card-body {
  margin-bottom: 20px;
}
.w-100 {
  width: 100%;
}

.supply {
  color: orange;
  font-size: 13px;
  font-weight: bold;
}
</style>